let locked = false;

// Inline styles (not a CSS class) so the lock works in every layout chunk. The lock
// only hides the ROOT scroller — it never repositions <body>: a position:fixed +
// top-offset lock drags statically-laid-out chrome (person sidebar, page content) up
// by the scroll offset and truncates the layout while a drawer or modal is open.
// Scroll position is naturally preserved because the scroller keeps its scrollTop;
// body padding compensates the vanished scrollbar so content never reflows sideways.
export const useScrollLock = () => {
    const lockScroll = () => {
        if (!import.meta.client || locked) return;
        locked = true;

        const { body, documentElement } = document;
        const scrollbarWidth = window.innerWidth - documentElement.clientWidth;
        if (scrollbarWidth > 0) body.style.paddingRight = `${scrollbarWidth}px`;
        documentElement.style.overflow = 'hidden';
        documentElement.style.overscrollBehavior = 'none';
    };

    const unlockScroll = () => {
        if (!import.meta.client || !locked) return;
        locked = false;

        const { body, documentElement } = document;
        body.style.removeProperty('padding-right');
        documentElement.style.removeProperty('overflow');
        documentElement.style.removeProperty('overscroll-behavior');
    };

    return { lockScroll, unlockScroll };
};
